import { render, staticRenderFns } from "./GerenciarAvaliacoes.vue?vue&type=template&id=8e0c581c"
import script from "./GerenciarAvaliacoes.vue?vue&type=script&lang=js"
export * from "./GerenciarAvaliacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports